/**
 * Standalone airline landing page settings for fastfares.info.
 * Intentionally NOT shared with the main car site, cruise pages, or /flight app.
 */

export const SW_BRAND = 'FastFares';
export const SW_BRAND_ACCENT = 'Fares';
export const SW_LOGO_BY = 'NodexTravel';
export const SW_DOMAIN = 'fastfares.info';
export const SW_TAGLINE = 'Compare live fares and get booking help any hour';

export const SW_PHONE = '1-888-401-4158';
export const SW_PHONE_RAW = '+18884014158';
export const SW_PHONE_DISPLAY = '+1 (888) 401-4158';
export const SW_EMAIL = 'info@nodexgloballlc.com';

export const SW_NAV = [
  { label: 'Home', href: '#swp-top' },
  { label: 'Flights', href: '#swp-search' },
  { label: 'Guide', href: '#swp-guide' },
  { label: 'FAQs', href: '#swp-faq' },
  { label: 'Contact', href: '#swp-contact' },
];

export const SW_DISCLAIMER = [
  `${SW_BRAND} (${SW_DOMAIN}) operates as an independent travel booking assistance service. We are not an airline and we are not affiliated with, endorsed by, or sponsored by any carrier named on this page.`,
  'Carrier names, logos, trademarks, and route details belong to their respective owners and appear here only for identification and descriptive purposes.',
  'Any sample fares are illustrative and may change without notice based on availability at ticketing. Baggage rules, change conditions, refunds, and loyalty benefits are set by the operating airline and always take priority over information shown here.',
];
